import { error as showErrorToast } from '@/plugins/toast';
// eslint-disable-next-line import/no-cycle
import {
  showSessionEndedDialog,
  buildSessionEndedMessage,
} from '@/helpers/authSession';

export default (http, { router, store }) => {
  http.interceptors.response.use(
    response => response,
    (error) => {
      if (error.response) {
        const { status, data = {} } = error.response;
        if (status === 401) {
          if (error.config.url === '/support-access/redeem') {
            return Promise.reject(error);
          }

          if (data.reason === 'licenseLimitReached') {
            store.commit('Auth.SET_LICENSE_EXCEEDED', true);
            error.response.data.message = 'Todas as licenças do seu plano estão em uso.';
            return Promise.reject(error);
          }

          if (['supportAccessExpired', 'supportAccessRevoked'].includes(data.reason)) {
            const message = data.reason === 'supportAccessRevoked'
              ? 'O acesso de suporte foi encerrado.'
              : 'O acesso de suporte expirou. Gere um novo acesso no Console.';
            showErrorToast(message, { timeout: 15000 });
            error.response.data.message = message;
          }

          if (data.reason === 'sessionInactive') {
            const logoutReason = data.logoutReason ?? null;
            const message = buildSessionEndedMessage({ logoutReason });
            // showErrorToast(message);
            showSessionEndedDialog({ logoutReason });
            error.response.data.message = message;
          }

          store.dispatch('resetAuthState');

          if (!['/auth', '/logout'].includes(error.config.url)) {
            router.push({ path: '/login' });
          }
        } else if (status === 403) {
          let message = 'Acesso negado';

          if (data.reason === 'accessNotAllowedAtThisTime') {
            message = 'Seu acesso está restrito a horários de trabalho configurados. '
              + 'Por favor, tente novamente durante o seu horário comercial.';
          } else if (data.reason === 'ipNotAllowed') {
            message = 'Seu endereço de IP não está autorizado a acessar o sistema';
          }

          showErrorToast(message, { timeout: 15000 });
          error.response.data.message = message;
        }
      }

      return Promise.reject(error);
    },
  );
};
